// Company data
export const CompanyName = 'The Tavistock Inn';
export const CompanyPhoneNumber = '01822 481240';
export const ContactEmailAddress = 'hello@thetavistockinn.co.uk';
export const DirectorName = 'Jon Inn';
export const CompanyAddress = '19 Brook Street, Tavistock, PL19 0HD';

// Site text
export const CompantTagLine = 'Traditional British Pub and Hotel.'

// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 10000;
export const CookiePolicyName = 'CookiePolicy';

// Pages
export const HOME_PAGE_URL = '/';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// API
export const LOGIN_API = '/login';
export const GET_LOGGED_IN_USER_API = '/users/user/get-logged-in-user'; // userId
export const REGISTER_API = '/users/register';
export const RESET_PASSWORD_API = '/users/user/reset-password'; // userId
export const SUBMIT_CONTACT_FORM_API = '/contact/submit-form'; // userId

// Bot Data
export const BotName = 'Jerry'

// Social Media URLs
export const FACEBOOK_URL = 'https://www.facebook.com/thetavistockhotelandinn';
export const INSTAGRAM_URL = 'https://www.instagram.com/thetavistockhotelandinn';
export const GOOGLE_URL = 'https://google.com/';
export const GITHUB_URL = 'https://github.com/';
export const APPLE_URL = 'https://apple.com/';
export const X_URL = 'https://x.com/';

// WebDeveloper Data
export const WebDeveloperBusinessName = 'ByteToast Studio'
export const WebDeveloperWebsiteAddress = 'www.bytetoast-studio.com'
export const WebDeveloperWebsiteUrl = 'https://bytetoast-studio.com'